// Official GF Smith Colorplan shade names (55) with approximate on-screen values.
// Real colour = physical swatch; each tile links to the official range page.
const GF = "https://shop.gfsmith.com/our-papers/colorplan";
export const COLORPLAN = [
  ["Bright White", "#F7F6F2"], ["Pristine White", "#F5F3EC"], ["Ice White", "#F2F3F1"], ["White Frost", "#EEF0F2"], ["China White", "#EFEBDF"],
  ["Vellum White", "#EDE6D6"], ["Natural", "#E9DFC9"], ["Stone", "#C8B9A3"], ["Mist", "#CFCBC1"], ["Pale Grey", "#C9C9C4"],
  ["Cool Grey", "#B5B8B6"], ["Real Grey", "#8F9192"], ["Smoke", "#7A7D7E"], ["Slate", "#5E6367"], ["Dark Grey", "#4A4C4E"],
  ["Ebony", "#1E1E1F"], ["Harvest", "#C9A64F"], ["Sorbet Yellow", "#F6E27A"], ["Factory Yellow", "#F2D22E"], ["Citrine", "#E6C200"],
  ["Chartreuse", "#C9D53A"], ["Mandarin", "#F07E1E"], ["Rust", "#B4562B"], ["Vermilion", "#E23E1A"], ["Bright Red", "#D8232A"],
  ["Scarlet", "#C41E3A"], ["Claret", "#6E1D2C"], ["Candy Pink", "#F4B6C6"], ["Hot Pink", "#E5327A"], ["Fuchsia Pink", "#C6297D"],
  ["Lavender", "#B9A7D3"], ["Amethyst", "#7B4C9E"], ["Purple", "#4B2A7B"], ["Cool Blue", "#9DC5E3"], ["Azure Blue", "#4FA3D8"],
  ["Turquoise", "#2FA8B8"], ["Adriatic", "#2B7FB2"], ["New Blue", "#3C6FB5"], ["Tabriz Blue", "#2C5FA3"], ["Marrs Green", "#2A8C7A"],
  ["Cobalt", "#1F4DA1"], ["Royal Blue", "#1F3B8F"], ["Sapphire", "#1B2F6E"], ["Imperial Blue", "#0F2352"], ["Pistachio", "#BFD8A5"],
  ["Powder Green", "#A9CDBA"], ["Mid Green", "#3E9A5C"], ["Park Green", "#2C7A4B"], ["Emerald", "#0E8A5B"], ["Lockwood Green", "#3B6B4F"],
  ["Racing Green", "#1B4332"], ["Forest", "#243B2A"], ["Nubuck Brown", "#8D6748"], ["Bagdad Brown", "#5C3A2E"], ["Bitter Chocolate", "#3B241C"],
];

const isLight = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  return (0.299 * r + 0.587 * g + 0.114 * b) > 160;
};

export function ColorplanSwatches() {
  return (
    <div className="not-prose my-8" data-testid="colorplan-swatches">
      <div className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-6 gap-2">
        {COLORPLAN.map(([name, hex]) => (
          <a
            key={name}
            href={GF}
            target="_blank"
            rel="noopener noreferrer"
            title={`${name} — view the real swatch on gfsmith.com`}
            className="group block border border-slate-200 hover:border-slate-900 transition-colors"
            data-testid={`swatch-${name.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="aspect-square" style={{ backgroundColor: hex }} />
            <div className={`px-2 py-1.5 text-[11px] font-bold leading-tight ${isLight(hex) ? "text-slate-800" : "text-slate-800"}`}>{name}</div>
          </a>
        ))}
      </div>
      <p className="mt-3 text-xs text-slate-500">
        {COLORPLAN.length} shades shown as approximate screen values. Uncoated paper reads differently under daylight and tungsten — order the
        <a href={GF} target="_blank" rel="noopener noreferrer" className="underline ml-1">official GF Smith swatch book</a> or ask us to send a physical sample with your quote.
      </p>
    </div>
  );
}
